module.exports = __webpack_public_path__ + "img/staff-2015-sports.b7ffbbbb.jpg";